export const BRAND = {
  nameEn: 'TAROMANCE',
  nameKo: '타로맨스',
  tagline: '타로와 칵테일, 대화가 만나는 문화 바',
  positioning: 'Tarot Experience Culture Bar',
  since: '2017',
  address: '서울특별시 강남구 도곡로11길 10 1층',
  postalCode: '06255',
  phoneDisplay: '0507-1361-9410',
  phoneLink: 'tel:0507-1361-9410',
  email: 'taromance@naver.com',
  owner: '김현규',
  bizNumber: '148-30-00518',
  hours: { label: '매일', time: '17:00 – 03:00' },
  amenities: ['예약', '무선인터넷', '주차', '간편결제', '남녀 화장실 구분']
} as const;

export const SERVICES = [
  {
    slug: '/tarot-consultation',
    labelEn: 'Tarot Consultation',
    title: '타로 상담',
    description: '16년 이상 경력의 전문 리더가 진행하는 타로 상담. 타로 상담은 무료입니다.',
    cta: '상담 안내 보기',
    image: '/assets/taromance/stitch-final/tarot-guide.jpg'
  },
  {
    slug: '/cocktail-menu',
    labelEn: 'Cocktail & Menu',
    title: '칵테일 & 메뉴',
    description: '메이저 아르카나를 맛과 향으로 재해석한 시그니처 컬렉션과 커스텀 칵테일.',
    cta: '메뉴 보기',
    image: '/assets/taromance/signature/the_star.jpg'
  },
  {
    slug: '/night-community',
    labelEn: 'Night Community',
    title: '나이트 커뮤니티',
    description: '대화와 취향이 이어지는 밤. 단골과 처음 온 손님이 자연스럽게 섞이는 공간입니다.',
    cta: '공간 소개 보기',
    image: '/assets/taromance/store/naver-store-01.jpg'
  },
  {
    slug: '/education-consulting',
    labelEn: 'Class & Consulting',
    title: '클래스 & 컨설팅',
    description: '타로 기초 클래스부터 모임·기업 출강, 타로 콘텐츠 제작 컨설팅까지.',
    cta: '강의·컨설팅 문의',
    image: '/assets/taromance/store/naver-drink-01.jpg'
  },
  {
    slug: '/archive',
    labelEn: 'Archive',
    title: '아카이브',
    description: '카드 상징과 리딩의 기초, 타로맨스의 기록을 모아둔 콘텐츠 허브.',
    cta: '콘텐츠 보기',
    image: '/assets/taromance/store/naver-store-02.jpg'
  }
] as const;

// 시그니처 아르카나 컬렉션 10종 — 어드민 미디어 기준, 메이저 아르카나 순서
export const SIGNATURE_COCKTAILS = [
  { name: 'The Fool', nameKo: '바보', arcana: 'Arcana 0', description: '가벼운 발걸음처럼 산뜻하게 시작되는 첫 잔입니다.', image: '/assets/taromance/signature/the_fool.jpg' },
  { name: 'The Magician', nameKo: '마법사', arcana: 'Arcana I', description: '시작의 에너지와 균형 잡힌 향이 또렷하게 펼쳐집니다.', image: '/assets/taromance/signature/the_magician.jpg' },
  { name: 'The Empress', nameKo: '여황제', arcana: 'Arcana III', description: '우아한 밀키 베이스에 감미로운 여운을 더했습니다.', image: '/assets/taromance/signature/the_empress.jpg' },
  { name: 'The Chariot', nameKo: '전차', arcana: 'Arcana VII', description: '곧게 나아가는 추진력을 단단한 바디감으로 담았습니다.', image: '/assets/taromance/signature/the_chariot.jpg' },
  { name: 'Wheel of Fortune', nameKo: '운명의 수레바퀴', arcana: 'Arcana X', description: '돌아오는 계절처럼 층층이 변하는 풍미가 이어집니다.', image: '/assets/taromance/signature/wheel_of_fortune.jpg' },
  { name: 'Death', nameKo: '죽음', arcana: 'Arcana XIII', description: '푸른 불꽃 뒤로 묵직한 변화의 여운이 남습니다.', image: '/assets/taromance/signature/death.jpg' },
  { name: 'Temperance', nameKo: '절제', arcana: 'Arcana XIV', description: '서로 다른 재료가 균형을 이루며 부드럽게 섞입니다.', image: '/assets/taromance/signature/temperance.jpg' },
  { name: 'The Star', nameKo: '별', arcana: 'Arcana XVII', description: '투명한 청량감 위로 섬세한 아로마가 번집니다.', image: '/assets/taromance/signature/the_star.jpg' },
  { name: 'The Sun', nameKo: '태양', arcana: 'Arcana XIX', description: '시트러스의 활기와 밝은 풍미를 산뜻하게 담았습니다.', image: '/assets/taromance/signature/the_sun.jpg' },
  { name: 'Judgement', nameKo: '심판', arcana: 'Arcana XX', description: '선명한 조율과 신비로운 색채가 감각을 깨웁니다.', image: '/assets/taromance/signature/judgement.jpg' }
] as const;
